<template>
  <div>

    <!-- :preview-src-list="fileList"  这里不用了，废弃 -->
    <el-image
      :src="fileList[0].url"
      v-if="fileList.length>0"
      fit="cover"
      :style="`width:${realWidth};height:${realHeight};`"
      @click="Showvideo"
    >
      <div slot="error" class="image-slot">
        <i class="el-icon-picture-outline"></i>
      </div>
    </el-image>

    <el-dialog
        :visible.sync="dialogVisible"
        title="预览"
        width="800"
      
        append-to-body
      >
      <el-row>
   <el-col :span="12" v-for=" item in fileList" :key="item.id+''">

    
  <div style="width: 400px;align-items: center;text-align: center;font-size: 16px;">{{ item.name }}</div>
    <video
    :style="`width:400px;height:208px`"
      v-if="item.type=='video'"
     
      controls
      :src="item.realurl"
    ></video>

    <iframe
      v-if="item.type=='excel'"
      :src="excelPreviewUrl"
      frameborder="0"
      width="100%"
      height="600"
    >
    </iframe>
 
   

  </el-col> 
</el-row>
</el-dialog>
  </div>                 
  </template>
  
  <script>
  import { getappends } from "@/api/system/dict/data";
  import{getVideoCover} from "@/utils/index";

  export default {
    name: "ImagePreview",
    props: {
      src: {
        type: String,
        default: "",
      },
      width: {
        type: [Number, String],
        default: "",
      },
      height: {
        type: [Number, String],
        default: "",
      },
    },
  
    data() {
      return {
        fileList: [],
        real:"",
        dialogVisible:false,
      };
    },
    watch: {
      src: {
        handler ( val ) {
          if (val) {
            this.fileList = [];
            this.realSrcList()
          } else {
            // this.fileList = [];
            // return [];
          }
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
     
      
      realWidth() {
        return typeof this.width == "string" ? this.width : `${this.width}px`;
      },
      realHeight() {
        return typeof this.height == "string" ? this.height : `${this.height}px`;
      },
    },
    created() {
      // this.realSrc();
      // this.realSrcList()
    
    },
    methods: {
  
      // 通过附件的ID，获取附件的详细信息
       getapp(item) {
         
        var that =this;
        return new Promise((resolve, reject) => {
             
              getappends(item).then(async (res) => {
            //  that.fileList.push( res.data.url );
         await   getVideoCover(res.data,that.fileList);
         if (that.fileList.length>0) {
          
         }
            //  that.fileList.push( {url: res.data.url,type: this.matchType(res.data.url),name:res.data.appendName} );
        });
              resolve()
   
      })
      },
      realSrc() {
        let that =this;
        if (!this.src) {
          console.log("返回的是空");
          
          return;
        }
        // let real_src =              this.src.split(",")[0] ;
        // return real_src;
        // return "http://127.0.0.1:9300/statics/baseinformation/school/top1_20240808152337A017.png";
  

        return;
        if (this.src.split(",")[0].length&&this.src.split(",")[0].length<40) {
          
          getappends(this.src.split(",")[0]).then( async (res) => {
            let real_src = res.data.url;
            console.log(real_src,"真实的图片");
            var filelist=[];
            await   getVideoCover(res.data,filelist).then(()=>{
              return that.real=  filelist[0].imgurl;
            });
          });
  
        }
      },
  
      realSrcList() {
        var that =this;
        if (!this.src) {
          return;
        }
        var real_src_list = this.src.split(",") || [];
        that. fileList =[],
        console.log(real_src_list,"需要遍历的对象");
        
    real_src_list.forEach(async (item,index)=> {

      if (item.length&&item.length>17) {
        return;
      }
      console.log(item,"打印出来附件ID");
      
          return new Promise(async (resolve, reject) => {
            if (item.length&&item.length<17) {
              
              await that.getapp(item);
            }
           
              resolve(
           
              )
   
          })
      })
  
   
  // ).then(() => {
      
  //     return that.fileList;
  // })
  
      },
      Showvideo(){
        this.dialogVisible=true
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .el-image {
    border-radius: 5px;
    background-color: #ebeef5;
    box-shadow: 0 0 5px 1px #ccc;
    ::v-deep .el-image__inner {
      transition: all 0.3s;
      cursor: pointer;
      &:hover {
        transform: scale(1.2);
      }
    }
    ::v-deep .image-slot {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      color: #909399;
      font-size: 30px;
    }
  }
  </style>
  